import { RouterPath } from "@/models/enum/routerPath";
import HelpView from "@/views/help-view/HelpView.vue";
import AboutTheActView from "@/views/help-view/AboutTheActView.vue";
import AboutTransparencyChainView from "@/views/help-view/AboutTransparencyChainView.vue";

const helpRoutes = [
  {
    path: RouterPath.Help,
    name: "help",
    component: HelpView,
  },
  {
    path: RouterPath.AboutTheAct,
    name: RouterPath.AboutTheAct,
    component: AboutTheActView,
  },
  {
    path: RouterPath.AboutTransparencyChain,
    name: RouterPath.AboutTransparencyChain,
    component: AboutTransparencyChainView,
  },
];

export default helpRoutes;
